<template>
    <div class="sh v--30">
        <!--{{instance}}-->
        <div v-if="instance.title || instance.content" class="sh__top v--15">
            <h2 v-if="instance.title" class="sh__title type--h2" v-html="instance.title"></h2>
            <div v-if="instance.content" class="sh__content type--content-links type--content-margins type--content-styles" v-html="instance.content"></div>
        </div>
        <div class="sh__list r v--10">
            <div v-if="isConditionMet(section)" v-for="(section, index) in instance.sections" :key="index" class="sh__section r">
                <ShowHide :shTitle="section.title" :shContent="section.content" />
            </div>
        </div>
    </div>
</template>

<script>
import ShowHide from "@c/elements/ShowHide.vue";
    export default {
        components: {
            ShowHide,
        },
        props: {
            instance: Object,
            siloData: Object,
        },
        methods: {
            // Let's you know if a single condition has been met
            isConditionMet(condition) {
                // If there is no condition, just show the show/hide
                if (condition.has_condition !== 'yes') { return true; }

                let returned = false;

                // Get field value from silodata
                let check = this.siloData.user.modules[condition.field];

                // Determine if it's an array and use the first instance if it is
                let check_value = Array.isArray(check) ? check[0] : check;

                // In the check from the panel it can only be a string
                if (check_value === null || check_value === "") {
                    check_value = "null";
                }

                if (condition.operator === 'is') {
                    if (condition.value === check_value) {
                        returned = true;
                    }
                }

                if (condition.operator === 'isnot') {
                    if (condition.value !== check_value) {
                        returned = true;
                    }
                }

                /*
                console.log('%cchecking is values', 'color:green;');
                console.log({
                    'slide':this.slide.order,
                    'check field':condition.field,
                    'check value':check_value,
                    'operator':condition.operator,
                    'value':condition.value,
                    'condition met':returned
                });
                */

                return returned;
            },
        }
    }
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.sh__list {

}
</style>